/* ─── XYRO Theme JS ─────────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  /* Cart Drawer ─────────────────────────────────────────────────────── */
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  let cartReqSeq = 0;   /* drops out-of-order /cart/change.js responses */
  let lastCartJSON = null;   /* skip re-render (and its stepper-teardown flash) when the cart is unchanged */
  const closeBtns = document.querySelectorAll('[data-cart-close]');

  /* ── State colour ──────────────────────────────────────────────────
     The cart chrome (titlebar, checkout, hover) matches the current page's
     state: the homepage hero's live selection, else the PDP's product,
     else lime. --state-accent is section-scoped so the drawer can't inherit
     it — we set --cart-accent on the drawer explicitly. Each cart line also
     gets its own --item-accent (from its handle) so its rail matches. */
  const STATE_ACCENT = {
    power: ['#ccff00', '204,255,0'],
    reset: ['#e8434a', '232,67,74'],
    sleep: ['#8ab4f8', '138,180,248'],
  };
  function handleAccent(handle) {
    if (!handle) return null;
    if (/power/i.test(handle)) return STATE_ACCENT.power;
    if (/reset/i.test(handle)) return STATE_ACCENT.reset;
    if (/sleep/i.test(handle)) return STATE_ACCENT.sleep;
    return null;
  }
  /* Zero-padded numeral ("01", "02") — matches the state-selector readout. */
  function padQty(n) { return String(n).padStart(2, '0'); }
  function applyCartAccent() {
    if (!drawer) return;
    const hero = document.querySelector('[data-active="power"],[data-active="reset"],[data-active="sleep"]');
    const key = hero ? hero.getAttribute('data-active') : (drawer.getAttribute('data-page-state') || '');
    const a = STATE_ACCENT[key];
    if (a) { drawer.style.setProperty('--cart-accent', a[0]); drawer.style.setProperty('--cart-accent-rgb', a[1]); }
    else { drawer.style.removeProperty('--cart-accent'); drawer.style.removeProperty('--cart-accent-rgb'); }
  }

  let cartReturnFocus = null;
  let cartPreviousOverflow = "";
  function openCart() {
    if (!drawer || drawer.classList.contains("open")) return;
    cartReturnFocus = document.activeElement;
    if (!cartReturnFocus || cartReturnFocus === document.body || cartReturnFocus.disabled) cartReturnFocus = document.querySelector(".site-header [data-cart-open]");
    if (cartReturnFocus?.closest("#mobile-menu")) cartReturnFocus = document.querySelector(".site-header__hamburger");
    document.dispatchEvent(new CustomEvent("xyro:close-menu"));
    cartPreviousOverflow = document.body.style.overflow;
    drawer.inert = false;
    drawer.setAttribute("aria-hidden", "false");
    applyCartAccent();
    drawer?.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]')?.focus();
    /* Peak-End: replay the free-shipping bar from 0 so it sweeps up to its
       level as the drawer lands — progress feels earned on every open. */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const fill = document.querySelector('#cart-progress .cart-progress__fill');
      if (fill && parseFloat(fill.style.width) > 0) {
        const target = fill.style.width;
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth;
        fill.style.transition = '';
        fill.style.width = target;
      }
    }
    /* Re-sync on every open: catches adds that didn't go through our own
       buttons (PDP forms, Appstle widgets, other tabs). Cached content
       paints instantly; this refresh reconciles in the background. */
    refreshCart();
  }

  /* Update the header badge; when the count INCREASES, fire a one-beat
     accent pulse (Peak-End: the "it landed" moment). animationend cleanup
     lets rapid consecutive adds re-fire. */
  function bumpCount(countEl, n) {
    if (!countEl) return;
    const prev = parseInt(countEl.textContent, 10) || 0;
    countEl.textContent = n;
    countEl.classList.toggle('is-visible', n > 0);
    if (n > prev) {
      countEl.classList.remove('is-pulsing');
      void countEl.offsetWidth;   /* restart the animation */
      countEl.classList.add('is-pulsing');
      countEl.addEventListener('animationend', function () {
        countEl.classList.remove('is-pulsing');
      }, { once: true });
    }
  }

  /* Optimistic add: merge the /cart/add.js response line into the cached cart
     and paint NOW, so the new item + its SUBSCRIPTION/ONE-TIME badge appear
     instantly instead of after the /cart.js roundtrip. refreshCart() reconciles
     exact totals a moment later. No-ops safely if there's no cached base. */
  function optimisticAdd(item) {
    if (!item || !item.key) return;
    let cart = null;
    try { cart = JSON.parse(sessionStorage.getItem('xyro:cart') || 'null'); } catch (e) {}
    if (!cart || !Array.isArray(cart.items)) return;
    const existing = cart.items.find(i => i.key === item.key);
    if (existing) existing.quantity = item.quantity;   /* add.js returns the line's new total qty */
    else cart.items.push(item);
    cart.item_count = cart.items.reduce((s, i) => s + i.quantity, 0);
    cart.total_price = cart.items.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);
    renderCart(cart);
  }
  function closeCart() {
    if (!drawer?.classList.contains('open')) return;
    if (cartReturnFocus?.isConnected) cartReturnFocus.focus();
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    drawer?.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = cartPreviousOverflow;
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.classList.contains('open')) { e.preventDefault(); closeCart(); }
  });
  drawer?.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const items = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(el => el.getClientRects().length);
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  });

  openBtns.forEach(b => b.addEventListener('click', openCart));
  closeBtns.forEach(b => b.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  /* Delegated close inside the drawer — rebuilt content (e.g. the empty-state
     "Build your stack →" link after a JS re-render) keeps working without
     rebinding per render. */
  drawer?.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  /* Add to Cart ─────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = 'ADDING...';
      btn.disabled = true;

      try {
        /* Form-encoded: JSON bodies drop selling plans on the Power
           variant in an existing cart (see product-stack-selector). */
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new URLSearchParams({ id: String(variantId), quantity: '1' })
        });
        if (res.ok) {
          let added = null; try { added = await res.json(); } catch (e) {}
          optimisticAdd(added);   /* paint the new line + its badge from cache NOW */
          openCart();             /* opens instantly; openCart() then reconciles */
          btn.textContent = btn.dataset.label || 'ADDED_TO_MANIFEST';
          setTimeout(() => {
            btn.textContent = btn.dataset.original || btn.dataset.label;
            btn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        btn.textContent = 'ERROR';
        btn.disabled = false;
      }
    });
  });

  /* Global cart API — other scripts (product-stack-selector's BUILD_STACK
     flow, etc.) must open/refresh the drawer through THIS renderer, not
     their own: a second renderer painting simplified line items was why a
     first add showed no +/- steppers or ONE-TIME/SUBSCRIPTION badge until
     the drawer was reopened. */
  window.XyroCart = { open: openCart, close: closeCart, refresh: () => refreshCart() };

  /* Refresh Cart ────────────────────────────────────────────────────── */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      /* Skip the full re-render (and its teardown flash) when nothing changed
         vs what's already painted — e.g. opening the drawer on an unchanged
         cart, or the post-open resync after our own optimistic update. */
      if (JSON.stringify(cart) === lastCartJSON) return;
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  /* In-place update of totals + each line's qty/price WITHOUT rebuilding the
     items list. Used after a quantity change when the line COUNT is unchanged,
     so the +/- steppers are never destroyed/recreated (that teardown was the
     visible lag — buttons flashing out and back). */
  function patchTotals(cart) {
    const cj = JSON.stringify(cart);
    lastCartJSON = cj;
    try { sessionStorage.setItem('xyro:cart', cj); } catch (e) {}
    const countEl = document.getElementById('cart-count');
    bumpCount(countEl, cart.item_count);
    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    const itemsEl = document.getElementById('cart-items');
    if (itemsEl) cart.items.forEach(item => {
      const row = itemsEl.querySelector('.cart-item[data-key="' + item.key + '"]');
      if (!row) return;
      const q = row.querySelector('.cart-item__qty'); if (q) q.textContent = padQty(item.quantity);
      const priceEl = row.querySelector('.cart-item__price');
      if (priceEl) {
        const spa = item.selling_plan_allocation;
        const compareAt = (spa && spa.compare_at_price) || item.original_price || 0;
        const showWas = !!spa && compareAt > item.price;
        const inner = showWas
          ? '<span class="cart-item__price-was">' + formatMoney(compareAt) + '</span><span class="cart-item__price-now">' + formatMoney(item.price) + '</span>'
          : formatMoney(item.price);
        priceEl.innerHTML = inner + ' × ' + item.quantity;
      }
    });
    renderShippingProgress(cart);
    renderCartUpsell(cart);
  }

  function renderCart(cart) {
    if (drawer) drawer.dataset.empty = String(cart.items.length === 0);
    const cj = JSON.stringify(cart);
    lastCartJSON = cj;
    try { sessionStorage.setItem('xyro:cart', cj); } catch (e) {}
    const itemsEl = document.getElementById('cart-items');
    const subtotalEl = document.getElementById('cart-subtotal');
    const countEl = document.getElementById('cart-count');

    bumpCount(countEl, cart.item_count);

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (!itemsEl) return;

    /* Capture the SERVER-rendered empty state (theme.liquid, which honours
       the editor's cart_empty_label setting) the first time through, and
       reuse it — a hardcoded string here was silently overriding whatever
       the merchant set in the editor. */
    if (!renderCart._emptyHTML) {
      const seed = itemsEl.querySelector('.cart-empty');
      renderCart._emptyHTML = seed ? seed.outerHTML
        : '<div class="cart-empty">Your stack is empty. <a class="cart-empty__cta" href="/#state-selector" data-cart-close>Build your stack →</a></div>';
    }

    if (cart.items.length === 0) {
      if (itemsEl.contains(document.activeElement)) drawer?.querySelector("[data-cart-close]")?.focus();
      itemsEl.innerHTML = renderCart._emptyHTML;
      return;
    }

    /* Subscription disclosure (ROSCA / FTC) ───────────────────────────────
       Every line item with a selling_plan_allocation is a recurring
       subscription. The Restore Online Shoppers' Confidence Act + Shopify
       subscription policy require clear-and-conspicuous disclosure of:
         (1) recurring billing nature
         (2) interval (every N days/weeks)
         (3) per-charge price
         (4) cancellation method
       BEFORE the customer hits checkout. We surface (1)+(2)+(4) inline on
       each cart line; (3) is already in the line's price. */
    itemsEl.innerHTML = cart.items.map(item => {
      const sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      const isSubscription = !!sp;
      const planName = isSubscription ? (sp.name || 'Subscription') : '';

      const subscriptionMeta = isSubscription
        ? `
          <div class="cart-item__sub-meta" data-sub-meta>
            <span class="cart-item__sub-badge" aria-label="Subscription">
              <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8a5 5 0 018.5-3.5L14 7M13 8a5 5 0 01-8.5 3.5L2 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11 4h3V1M5 12H2v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              SUBSCRIPTION
            </span>
            <span class="cart-item__sub-plan">${escapeHtml(planName)} · Cancel anytime from your account.</span>
          </div>
        `
        : '';

      /* One-time badge — mirrors the subscription badge so a non-sub line is
         clearly labelled too. Neutral styling so Subscribe still stands out. */
      const oneTimeMeta = !isSubscription
        ? `
          <div class="cart-item__sub-meta cart-item__sub-meta--once">
            <span class="cart-item__sub-badge cart-item__sub-badge--once" aria-label="One-time purchase">
              <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M8 1.6l5.6 2.8v6.4L8 13.6 2.4 10.8V4.4L8 1.6z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
                <path d="M2.4 4.4L8 7.2l5.6-2.8M8 7.2v6.4" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
              </svg>
              ONE-TIME
            </span>
          </div>
        `
        : '';

      /* Subscription lines show the one-time price struck through next to the
         discounted recurring price — the −20% made visible. compare_at_price
         on the allocation is the no-subscription price; fall back to the
         line's original_price. */
      const spa = item.selling_plan_allocation;
      const compareAt = (spa && spa.compare_at_price) || item.original_price || 0;
      const showWas = isSubscription && compareAt > item.price;
      const priceInner = showWas
        ? `<span class="cart-item__price-was">${formatMoney(compareAt)}</span><span class="cart-item__price-now">${formatMoney(item.price)}</span>`
        : `${formatMoney(item.price)}`;

      const ia = handleAccent(item.handle);
      const itemStyle = ia ? ` style="--item-accent:${ia[0]};--item-accent-rgb:${ia[1]}"` : '';

      return `
      <div class="cart-item" data-key="${item.key}" data-subscription="${isSubscription ? '1' : '0'}"${itemStyle}>
        <img class="cart-item__img" src="${item.image}" alt="${escapeHtml(item.title)}">
        <div class="cart-item__info">
          <div class="cart-item__head">
            <div class="cart-item__name">${escapeHtml(item.title)}</div>
            <div class="cart-item__qty-wrap">
              <button class="cart-item__qty-btn" data-change="-1" data-key="${item.key}" aria-label="Decrease quantity">−</button>
              <span class="cart-item__qty">${padQty(item.quantity)}</span>
              <button class="cart-item__qty-btn" data-change="1" data-key="${item.key}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="cart-item__price">${priceInner} × ${item.quantity}</div>
          ${subscriptionMeta}${oneTimeMeta}
        </div>
      </div>
      `;
    }).join('');

    // Qty change
    itemsEl.querySelectorAll('[data-change]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const change = parseInt(btn.dataset.change);
        /* Optimistic: bump the displayed number NOW (read the shown value so
           rapid taps compound correctly), send the absolute quantity, and
           reconcile from the response. The seq guard drops stale responses
           when taps overlap. */
        const qtyEl = btn.parentElement.querySelector('.cart-item__qty');
        const shown = parseInt((qtyEl && qtyEl.textContent) || '0', 10);
        const newQty = Math.max(0, shown + change);
        if (qtyEl) qtyEl.textContent = padQty(newQty);
        const seq = ++cartReqSeq;
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        if (res.ok) {
          const c = await res.json();
          if (seq !== cartReqSeq) return;   /* a newer tap already won */
          /* Line count unchanged -> patch in place (no stepper teardown).
             Only full-rebuild when a line appeared or vanished (qty hit 0). */
          const domCount = itemsEl.querySelectorAll('.cart-item').length;
          if (c.items.length === domCount && c.items.length > 0) patchTotals(c);
          else renderCart(c);
        }
        else { refreshCart(); }
      });
    });

    // ── Free-shipping progress bar ─────────────────────────────────
    // Hidden when no threshold configured (0). Otherwise shows the
    // distance-to-free-shipping or an "Unlocked" success state.
    renderShippingProgress(cart);

    // ── Missing-state upsell ───────────────────────────────────────
    // Reads the data-upsell-config blob from the cart-upsell wrapper,
    // intersects the configured XYRO state handles against the
    // cart's current product handles, and renders a one-tap
    // upsell tile for each missing state. Hidden when the cart is
    // empty or when all 3 states are already in the cart.
    renderCartUpsell(cart);
  }

  /* Free-shipping progress bar ──────────────────────────────────────
     Reads the threshold-in-cents from data-threshold-cents on the
     wrapper. Updates the fill width + the messaging line. Hides
     entirely when threshold = 0 or the cart is empty. */
  function renderShippingProgress(cart) {
    const wrap = document.getElementById('cart-progress');
    if (!wrap) return;
    const threshold = parseInt(wrap.dataset.thresholdCents, 10);
    if (!threshold || threshold <= 0 || cart.item_count === 0) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    const subtotal = cart.total_price; // in cents
    const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    const fillEl = wrap.querySelector('[data-cart-progress-fill]');
    const msgEl  = wrap.querySelector('[data-cart-progress-msg]');
    if (fillEl) fillEl.style.width = pct + '%';
    if (msgEl) {
      if (subtotal >= threshold) {
        msgEl.textContent = 'Shipping at no additional charge.';
        wrap.dataset.state = 'unlocked';
      } else {
        const remaining = '$' + ((threshold - subtotal) / 100).toFixed(2);
        msgEl.textContent = remaining + ' away from shipping at no additional charge.';
        wrap.dataset.state = 'progress';
      }
    }
  }

  /* Appstle subscription plan (20% off recurring) — fallback used by the
     cart upsell's Subscribe button when the product JSON doesn't surface a
     selling plan. Matches the plan wired on the PDP stack selector. */
  const UPSELL_FALLBACK_PLAN = 691827998904;

  /* Missing-state cart upsell ──────────────────────────────────────
     For each XYRO state SKU that's NOT in the cart, render one-time +
     subscribe tiles. Helps complete the 3-SKU stack and lifts AOV.
     Hidden when the cart is empty or all 3 states are already in. */
  function renderCartUpsell(cart) {
    const wrap = document.getElementById('cart-upsell');
    if (!wrap) return;
    let config;
    try { config = JSON.parse(wrap.dataset.upsellConfig || '{}'); }
    catch (e) { wrap.hidden = true; return; }
    if (!config.states || !config.states.length) { wrap.hidden = true; return; }
    if (cart.item_count === 0)                   { wrap.hidden = true; return; }

    const cartHandles = new Set(cart.items.map(i => i.handle));
    const missing = config.states.filter(s => !cartHandles.has(s.handle));
    if (missing.length === 0 || missing.length === config.states.length) {
      // Either all states already in cart, OR the cart has only non-
      // XYRO items (no signal to upsell). Hide either way.
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    wrap.innerHTML = `
      <p class="cart-upsell__label">// COMPLETE YOUR STACK</p>
      <div class="cart-upsell__list">
        ${missing.map(s => `
          <div class="cart-upsell__item"
               style="--upsell-accent:${s.accent}"
               data-upsell-handle="${escapeHtml(s.handle)}">
            <div class="cart-upsell__copy">
              <span class="cart-upsell__title">${escapeHtml(s.title)}</span>
              <span class="cart-upsell__tagline">${escapeHtml(s.tagline)}</span>
            </div>
            <div class="cart-upsell__actions">
              <button type="button"
                      class="cart-upsell__add cart-upsell__add--sub"
                      data-upsell-add data-mode="sub"
                      data-handle="${escapeHtml(s.handle)}">
<span class="cart-upsell__add-label">SUB −20%</span>${s.sub_price ? `<span class="cart-upsell__add-sep"> · </span><span class="cart-upsell__add-price">${formatMoney(s.sub_price)}</span>` : ''}
              </button>
              <button type="button"
                      class="cart-upsell__add cart-upsell__add--once"
                      data-upsell-add data-mode="once"
                      data-handle="${escapeHtml(s.handle)}">
<span class="cart-upsell__add-label">ONE-TIME</span>${s.price ? `<span class="cart-upsell__add-sep"> · </span><span class="cart-upsell__add-price">${formatMoney(s.price)}</span>` : ''}
              </button>
            </div>
          </div>
        `).join('')}
      </div>
    `;

    // Wire each button: fetch the product, take its first available variant,
    // add 1 to cart — one-time, or as a subscription (selling_plan) for the
    // Subscribe button — then re-render. The subscription plan id is read
    // from the product's selling_plan_groups, falling back to the brand's
    // Appstle plan (20% off recurring) if the product JSON omits it.
    wrap.querySelectorAll('[data-upsell-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const handle = btn.dataset.handle;
        const mode   = btn.dataset.mode;
        const tile   = btn.closest('.cart-upsell__item');
        const tileBtns = tile ? tile.querySelectorAll('[data-upsell-add]') : [btn];
        tileBtns.forEach(b => { b.disabled = true; });   /* :disabled style = loading affordance; keeps the label/price */
        try {
          const st = (config.states || []).find(s => s.handle === handle) || {};
          let variantId = st.variant_id;
          let planId = mode === 'sub' ? (st.selling_plan_id || UPSELL_FALLBACK_PLAN) : null;
          /* Use the variant + plan already in the upsell config so we skip the
             extra /products/<handle>.js roundtrip (the main upsell-add lag).
             Only fall back to fetching if the config lacked a variant id. */
          if (!variantId) {
            const prod = await (await fetch('/products/' + handle + '.js')).json();
            const variant = (prod.variants || []).find(v => v.available) || prod.variants[0];
            if (!variant) throw new Error('no variant');
            variantId = variant.id;
            if (mode === 'sub') {
              const plans = (prod.selling_plan_groups && prod.selling_plan_groups[0] && prod.selling_plan_groups[0].selling_plans) || [];
              planId = (plans[0] && plans[0].id) || UPSELL_FALLBACK_PLAN;
            }
          }
          const body = new URLSearchParams({ id: String(variantId), quantity: '1' });
          if (planId) body.append('selling_plan', String(planId));
          /* Form-encoded: JSON bodies drop selling plans on the Power
             variant in an existing cart (see product-stack-selector). */
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body
          });
          let added = null; try { added = await addRes.json(); } catch (e) {}
          optimisticAdd(added);   /* the new line paints + this tile removes instantly */
          refreshCart();          /* reconcile exact totals */
        } catch (err) {
          console.error('Upsell add failed', err);
          tileBtns.forEach(b => { b.disabled = false; });
        }
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Lightweight HTML escape — used inside renderCart() template literals
     to prevent product titles or selling-plan names from breaking the
     markup if they contain &, <, > or quotes. */
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Initial cart load — paint the last known cart instantly (badges, prices
  // and count appear with zero network wait), then refresh from the server.
  try {
    const cached = sessionStorage.getItem('xyro:cart');
    if (cached) renderCart(JSON.parse(cached));
  } catch (e) {}
  applyCartAccent();
  refreshCart();

  /* Scroll Animations ───────────────────────────────────────────────── */
  // In the Shopify theme editor, skip animation entirely so content stays visible
  function observeFadeUps(root) {
    if (window.Shopify && window.Shopify.designMode) {
      (root || document).querySelectorAll('.fade-up').forEach(el => el.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Stagger: if parent has .stagger class, apply sibling-index delay.
          // Manual override: data-stagger="<n>" forces a specific multiplier.
          const el = entry.target;
          const manualIdx = el.dataset.stagger != null ? parseInt(el.dataset.stagger, 10) : null;
          const parent = el.parentElement;
          if (manualIdx !== null && !isNaN(manualIdx)) {
            el.style.transitionDelay = (manualIdx * 0.08) + 's';
          } else if (parent && parent.classList.contains('stagger')) {
            const siblings = parent.querySelectorAll(':scope > .fade-up');
            const idx = Array.prototype.indexOf.call(siblings, el);
            if (idx > 0) el.style.transitionDelay = (idx * 0.08) + 's';
          }
          el.classList.add('visible');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.1 });
    (root || document).querySelectorAll('.fade-up').forEach(el => obs.observe(el));
  }

  observeFadeUps();

  // Re-observe when the theme editor reloads a section
  document.addEventListener('shopify:section:load', function(e) {
    observeFadeUps(e.target);
  });

  /* Variant Selection ────────────────────────────────────────────────── */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const form = btn.closest('form');
      form?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const addBtn = form?.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.dataset.variantId = btn.dataset.variantId;
    });
  });

  /* Filter buttons ───────────────────────────────────────────────────── */
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
    });
  });

  /* Mobile menu toggle ───────────────────────────────────────────────── */
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  menuToggle?.addEventListener('click', () => {
    mobileMenu?.classList.toggle('open');
  });

});

/* Fade-up CSS injected by JS ──────────────────────────────────────────── */
const style = document.createElement('style');
style.textContent = `
  .fade-up {
    opacity: 0;
    transform: translateY(30px);
    transition:
      opacity var(--dur-slow, 0.6s) var(--ease-out-cinematic, cubic-bezier(0.16, 1, 0.3, 1)),
      transform var(--dur-slow, 0.6s) var(--ease-out-cinematic, cubic-bezier(0.16, 1, 0.3, 1));
  }
  .fade-up.visible { opacity: 1; transform: translateY(0); }
  @media (prefers-reduced-motion: reduce) {
    .fade-up { opacity: 1; transform: none; transition: none; }
  }
`;
document.head.appendChild(style);

/* Cinematic scroll — scroll-tied ambient drift ────────────────────────────
   Shifts the global `html::before` state-tinted radial gradient's vertical
   center from 45% → 70% as the user scrolls down the page. The atmospheric
   field appears to follow the user, giving the page a sense of depth-of-
   field rather than a static colored overlay.

   rAF-throttled so scroll events don't spam the layout thread.
   `prefers-reduced-motion` opts out entirely. */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const docEl = document.documentElement;
  const MIN_Y = 45;
  const MAX_Y = 70;
  const SCROLL_RANGE = 3; /* in viewport heights — drift completes after ~3 screens */

  let lastY = 0;
  let ticking = false;
  let lastAmb = null;
  let lastShift = null;

  function update() {
    const vh = window.innerHeight || 1;
    const progress = Math.min(1, Math.max(0, lastY / (vh * SCROLL_RANGE)));
    /* Quantised to 0.5% steps and written only on change: the ambient
       field is a full-viewport fixed radial gradient (html::before), and
       every write repaints the whole viewport. Per-pixel updates meant a
       full-screen repaint on every scroll frame; 50 steps across the
       whole drift is visually identical. */
    const y = Math.round((MIN_Y + (MAX_Y - MIN_Y) * progress) * 2) / 2;
    if (y !== lastAmb) { lastAmb = y; docEl.style.setProperty('--xyro-amb-y', y + '%'); }
    /* Scroll-tracked global grid drift — the fixed grid pattern is 80px
       periodic, so translating it by -(scrollY mod 80) is identical to
       shifting background-position by -scrollY, but transform-only
       (no re-raster). Consumed by .xyro-grid-bg::before. */
    const shift = -(((lastY % 80) + 80) % 80);
    if (shift !== lastShift) { lastShift = shift; docEl.style.setProperty('--xyro-grid-shift', shift + 'px'); }
    ticking = false;
  }

  function onScroll() {
    lastY = window.scrollY || window.pageYOffset || 0;
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  /* Initial paint */
  onScroll();
})();

/* ─── Seamless per-section grid alignment ─────────────────────────────────
   Each .xyro-gridded section paints its grid in a .xyro-grid-layer child.
   To make the 80px lines run continuously across section seams, every
   section is offset to a common document origin: --xyro-sec-top holds the
   section's distance from the top of the document, and the CSS shifts the
   grid up by that amount. Recomputed on load, resize, and after fonts so
   layout shifts don't break alignment. */
(function () {
  if (typeof window === 'undefined') return;
  var GRID = 80;

  function injectLayers() {
    var sections = document.querySelectorAll('.xyro-gridded');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (!s.querySelector(':scope > .xyro-grid-layer')) {
        var layer = document.createElement('div');
        layer.className = 'xyro-grid-layer';
        layer.setAttribute('aria-hidden', 'true');
        /* Appended (not prepended) so we don't disturb any :first-child
           rules; z-index:-1 keeps it behind content regardless of order. */
        s.appendChild(layer);
      }
    }
  }

  function syncOffsets() {
    var sections = document.querySelectorAll('.xyro-gridded');
    var scrollY = window.scrollY || window.pageYOffset || 0;
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      var top = s.getBoundingClientRect().top + scrollY;
      /* Modulo the grid size — only the phase matters, keeps the number small. */
      var phase = ((top % GRID) + GRID) % GRID;
      s.style.setProperty('--xyro-sec-top', phase.toFixed(2) + 'px');
    }
  }

  function run() { injectLayers(); syncOffsets(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', syncOffsets);
  /* Throttle resize via rAF AND short-circuit during pinch zoom on
     iOS Safari. Pinch zoom fires hundreds of resize events per
     second even though the layout viewport hasn't actually changed,
     and syncOffsets iterates every .xyro-gridded section calling
     getBoundingClientRect(). Combined with the rest of the page's
     resize handlers (Three.js renderer in product-interaction,
     etc.) this was triggering memory pressure / crashes on zoom.
     The visualViewport.scale > 1.05 check skips the handler while
     the user is zoomed; we re-sync once they zoom back to 1.0. */
  var resizeRaf = 0;
  window.addEventListener('resize', function () {
    if (resizeRaf) return;
    if (window.visualViewport && window.visualViewport.scale > 1.05) return;
    resizeRaf = requestAnimationFrame(function () {
      resizeRaf = 0;
      syncOffsets();
    });
  }, { passive: true });
  /* Re-sync when the user finishes a pinch zoom and the visual viewport
     settles back to 1.0 — the previous skip would have left the grid
     phase un-recomputed. */
  if (window.visualViewport) {
    var vvRaf = 0;
    window.visualViewport.addEventListener('resize', function () {
      if (vvRaf) return;
      if (window.visualViewport.scale > 1.05) return;
      vvRaf = requestAnimationFrame(function () {
        vvRaf = 0;
        syncOffsets();
      });
    }, { passive: true });
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncOffsets).catch(function () {});
  }
  /* A couple of delayed re-syncs catch late layout shifts (images, video). */
  setTimeout(syncOffsets, 600);
  setTimeout(syncOffsets, 1800);
})();

/* ─── Global state sync ──────────────────────────────────────────────────
   Listens to state-change clicks + data-active mutations across the three
   homepage state engines (Hero OS, System Analysis, State Protocol) and:
     1. Broadcasts the new state to the other two sections so they follow
     2. Toggles a body class (.state-power|.state-reset|.state-sleep) so
        every CSS rule reading var(--state-accent) repaints in lockstep.
   Brand chrome that consumes var(--lime) is unaffected — only the page
   accent system swaps with state. */
(function () {
  var STATES = ['power', 'reset', 'sleep'];
  var syncing = false; // re-entrancy guard so programmatic clicks don't loop
  var STORAGE_KEY = 'xyro:active-state';

  function persistState(state) {
    try { localStorage.setItem(STORAGE_KEY, state); } catch (e) {}
  }
  function readPersistedState() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  /* Day-part window from the visitor's clock: daytime 06:00-16:59 (Power),
     evening 17:00-20:59 (Reset), night 21:00-05:59 (Sleep). Time only;
     nothing here is a direction for use. */
  function windowOfDay() { var h = new Date().getHours(); return (h >= 21 || h < 6) ? 'night' : (h >= 17 ? 'evening' : 'daytime'); }
  function windowState() { var w = windowOfDay(); return w === 'night' ? 'sleep' : (w === 'evening' ? 'reset' : 'power'); }
  window.XyroWindow = { of: windowOfDay, state: windowState };
  function markTouched() { try { sessionStorage.setItem('xyro:state-touched', '1'); } catch (e) {} }
  function wasTouched() { try { return sessionStorage.getItem('xyro:state-touched') === '1'; } catch (e) { return false; } }
  function applyBodyState(state) {
    if (STATES.indexOf(state) === -1) return;
    var body = document.body;
    body.classList.remove('state-power', 'state-reset', 'state-sleep');
    body.classList.add('state-' + state);
    persistState(state);
  }

  function syncSections(state, source) {
    if (syncing) return;
    syncing = true;
    var idx = STATES.indexOf(state);

    var heroBtn = document.querySelector('.xos__state-btn[data-btn-state="' + state + '"]');
    if (heroBtn && heroBtn !== source) heroBtn.click();

    var sysBtn = document.querySelector('.sys__state[data-go="' + idx + '"]');
    if (sysBtn && sysBtn !== source) sysBtn.click();

    var chipBtn = document.querySelector('[data-state-protocol] .chip[data-chip="' + idx + '"]');
    if (chipBtn && chipBtn !== source) chipBtn.click();

    /* Stack selector — tile mapping: power=tile 1, reset=tile 2, sleep=tile 3.
       The stack selector's tiles are class="xyro-product-tile-<sectionId>"
       so we use an attribute selector that matches any instance.

       Click only if the tile is NOT already selected. The tile click
       handler is a toggle — clicking an already-selected tile would
       *deselect* it, destroying any "all three" or multi-stack
       selection the user has built and persisted via localStorage. */
    var stackTile = document.querySelector('[class*="xyro-product-tile-"][data-product-index="' + (idx + 1) + '"]');
    if (stackTile && stackTile !== source && !stackTile.classList.contains('selected')) {
      stackTile.click();
    }

    requestAnimationFrame(function () { syncing = false; });
  }

  /* 1) Click capture — runs before each section's own click handler */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.xos__state-btn, .sys__state, .chip[data-chip], .dial .stop[data-stop]');
    if (!btn) return;
    var state = btn.dataset.btnState
             || STATES[parseInt(btn.dataset.go, 10)]
             || STATES[parseInt(btn.dataset.chip, 10)]
             || STATES[parseInt(btn.dataset.stop, 10)];
    if (!state) return;
    markTouched();
    applyBodyState(state);
    syncSections(state, btn);
  }, true);

  /* 2) MutationObserver — catches keyboard/drag/wheel changes inside
        hero-os and system-analysis (both update data-active on every
        state change regardless of trigger). */
  function observeRoot(rootEl, mapToState) {
    if (!rootEl) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName !== 'data-active') continue;
        var state = mapToState(rootEl.getAttribute('data-active'));
        if (state) {
          markTouched();
          applyBodyState(state);
          syncSections(state, null);
        }
      }
    }).observe(rootEl, { attributes: true, attributeFilter: ['data-active'] });
  }

  function init() {
    document.querySelectorAll('.xos[data-active]').forEach(function (el) {
      observeRoot(el, function (v) { return v; });
    });
    document.querySelectorAll('.sys[data-active]').forEach(function (el) {
      observeRoot(el, function (v) { return STATES[parseInt(v, 10)]; });
    });
    /* Product carousel (arrows, swipe, rail): drives the page state too, so
       a follow-state hero above it tracks the slide even when hero-os is off. */
    document.querySelectorAll('.xps[data-active]').forEach(function (el) {
      observeRoot(el, function (v) { return v; });
    });

    /* 3) Initial body class.
          - On PDP templates (template-product-power | reset | sleep)
            the body class is LOCKED to the product. The persisted home
            state must never override the page the user is actually on.
            We also re-persist the PDP's state so when the user
            navigates back home, they land on the matching state.
          - On non-PDP pages (homepage etc.), restore from localStorage
            so the user's last selection survives reloads. */
    var bodyClassList = document.body.classList;
    var pdpState =
      bodyClassList.contains('template-product-power') ? 'power' :
      bodyClassList.contains('template-product-reset') ? 'reset' :
      bodyClassList.contains('template-product-sleep') ? 'sleep' :
      null;

    var initial;
    if (pdpState) {
      initial = pdpState;
      persistState(pdpState);          /* sync localStorage to template */
    } else {
      /* Fresh session: open on the state whose window is open right now.
         Once the visitor has picked a state this session, keep their pick. */
      var persisted = readPersistedState();
      initial = (wasTouched() && persisted && STATES.indexOf(persisted) !== -1) ? persisted : windowState();
    }
    /* Window-aware status strings (footer, routines sysline). */
    var winLabel = windowOfDay().toUpperCase() + ' WINDOW: OPEN';
    document.querySelectorAll('[data-window-status]').forEach(function (el) { el.textContent = winLabel + ' // STATUS: ONLINE'; });
    document.querySelectorAll('[data-window-sysline]').forEach(function (el) { el.textContent = winLabel; });
    applyBodyState(initial);
    /* Sync all section UIs to the persisted state after a tick so each
       section's own JS has had a chance to register its handlers. */
    requestAnimationFrame(function () {
      syncSections(initial, null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─── Routine log (local tier) ───────────────────────────────────────────
   Today ticks for the three states, kept ONLY in this browser's localStorage
   under `xyro:routine` ({ v:1, days: { "YYYY-MM-DD": ["power","reset"] } }),
   pruned to the last 90 days. Nothing is sent anywhere. "Days kept" counts a
   day when XYRO Power or XYRO Reset is ticked; XYRO Sleep is never counted
   (occasional use only, per the pack). Renders every [data-routine-log]
   instance (cart drawer, Mission page) and keeps them in sync, across tabs
   too via the storage event. */
(function () {
  var KEY = 'xyro:routine', KEEP_DAYS = 90;
  var STATES = ['power', 'reset', 'sleep'], COUNTED = ['power', 'reset'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dateStr(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function offset(n) { var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + n); return d; }
  function today() { return dateStr(offset(0)); }
  function load() {
    var j;
    try { j = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { j = null; }
    if (!j || typeof j !== 'object' || !j.days) j = { v: 1, days: {} };
    var cutoff = dateStr(offset(-KEEP_DAYS));
    Object.keys(j.days).forEach(function (k) { if (k < cutoff) delete j.days[k]; });
    return j;
  }
  function save(j) { try { localStorage.setItem(KEY, JSON.stringify(j)); } catch (e) {} }
  function toggle(state, day) {
    if (STATES.indexOf(state) < 0) return;
    var j = load(), t = day || today(), arr = j.days[t] || [], i = arr.indexOf(state);
    if (t > today()) return;   /* never log the future */
    if (i >= 0) arr.splice(i, 1); else arr.push(state);
    if (arr.length) j.days[t] = arr; else delete j.days[t];
    save(j); renderAll();
  }
  function week() {
    var out = [];
    for (var i = 6; i >= 0; i--) { var d = offset(-i); out.push({ key: dateStr(d), label: 'SMTWTFS'.charAt(d.getDay()), today: i === 0 }); }
    return out;
  }
  function isKept(arr) { return arr.some(function (s) { return COUNTED.indexOf(s) >= 0; }); }
  function fmt(key) {
    var parts = key.split('-'), d = new Date(+parts[0], +parts[1] - 1, +parts[2], 12);
    try { return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }).toUpperCase(); } catch (e) { return key; }
  }
  /* Historic logging: a week/month cell can be selected (data-rlog-day on the
     instance); the Today row then edits that day until "Back to today". */
  function selectedDay(el) {
    var sel = el.getAttribute('data-rlog-day'), t = today(), floor = dateStr(offset(-27));
    if (!sel || sel > t || sel < floor) { sel = t; el.removeAttribute('data-rlog-day'); }
    return sel;
  }
  function render(el) {
    var j = load(), t = today(), sel = selectedDay(el), arr = j.days[sel] || [], editing = sel !== t;
    el.querySelectorAll('[data-rlog-state]').forEach(function (b) {
      b.setAttribute('aria-pressed', arr.indexOf(b.getAttribute('data-rlog-state')) >= 0 ? 'true' : 'false');
    });
    var dateEl = el.querySelector('[data-rlog-date]');
    if (dateEl) dateEl.textContent = fmt(sel);
    var eye = el.querySelector('[data-rlog-eyebrow]');
    if (eye) eye.textContent = editing ? '// EDITING' : '// TODAY';
    var back = el.querySelector('[data-rlog-today]');
    if (back) back.hidden = !editing;
    el.classList.toggle('is-editing', editing);
    var days = week(), kept = days.filter(function (w) { return isKept(j.days[w.key] || []); }).length;
    var sum = el.querySelector('[data-rlog-summary]');
    if (sum) {
      var text = kept + ' of 7 days kept this week';
      if (el.querySelector('[data-rlog-month]')) {
        /* Weeks kept: rolling 7-day blocks over the stored 90 days, a week
           counts when 5 or more of its days were kept. Grows slowly, never
           punishes one missed day. */
        var weeks = 0;
        for (var wb = 0; wb < 13; wb++) {
          var n = 0;
          for (var dj = 0; dj < 7; dj++) { if (isKept(j.days[dateStr(offset(-(wb * 7 + dj)))] || [])) n++; }
          if (n >= 5) weeks++;
        }
        text += ' \u00b7 ' + weeks + (weeks === 1 ? ' week kept' : ' weeks kept') + ' (5+ days)';
      }
      sum.textContent = text;
    }
    var empty = el.querySelector('[data-rlog-empty]');
    if (empty) empty.hidden = Object.keys(j.days).length > 0;
    var mo = el.querySelector('[data-rlog-month]');
    if (mo) {
      var html = '';
      for (var w4 = 3; w4 >= 0; w4--) {
        var rowKept = 0, cells = '';
        for (var di = 6; di >= 0; di--) {
          var dd = offset(-(w4 * 7 + di)), k = dateStr(dd), a2 = j.days[k] || [], tod = (w4 === 0 && di === 0);
          if (isKept(a2)) rowKept++;
          cells += '<button type="button" class="rlog__day' + (tod ? ' is-today' : '') + (isKept(a2) ? ' is-kept' : '') + (k === sel ? ' is-selected' : '') + '" data-rlog-day="' + k + '" aria-label="' + fmt(k) + '" aria-pressed="' + (k === sel ? 'true' : 'false') + '">' +
            '<span class="rlog__day-l">' + 'SMTWTFS'.charAt(dd.getDay()) + '</span><span class="rlog__day-dots">' +
            STATES.map(function (s) { return '<i class="rlog__dot rlog__dot--' + s + (a2.indexOf(s) >= 0 ? ' is-on' : '') + '"></i>'; }).join('') +
            '</span></button>';
        }
        html += '<span class="rlog__month-l">' + (w4 === 0 ? 'This week' : w4 + ' wk ago') + '</span>' + cells +
                '<span class="rlog__month-k' + (rowKept === 7 ? ' is-full' : '') + '">' + rowKept + '/7</span>';
      }
      mo.innerHTML = html;
    }
    var wk = el.querySelector('[data-rlog-week]');
    if (wk) {
      wk.innerHTML = days.map(function (w) {
        var a = j.days[w.key] || [];
        return '<button type="button" class="rlog__day' + (w.today ? ' is-today' : '') + (isKept(a) ? ' is-kept' : '') + (w.key === sel ? ' is-selected' : '') + '" data-rlog-day="' + w.key + '" aria-label="' + fmt(w.key) + '" aria-pressed="' + (w.key === sel ? 'true' : 'false') + '">' +
          '<span class="rlog__day-l">' + w.label + '</span><span class="rlog__day-dots">' +
          STATES.map(function (s) { return '<i class="rlog__dot rlog__dot--' + s + (a.indexOf(s) >= 0 ? ' is-on' : '') + '"></i>'; }).join('') +
          '</span></button>';
      }).join('');
    }
  }
  function renderAll() { document.querySelectorAll('[data-routine-log]').forEach(render); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rlog-state]');
    if (b) { var inst = b.closest('[data-routine-log]'); toggle(b.getAttribute('data-rlog-state'), inst ? selectedDay(inst) : today()); return; }
    var back = e.target.closest('[data-rlog-today]');
    if (back) { var h2 = back.closest('[data-routine-log]'); if (h2) { h2.removeAttribute('data-rlog-day'); render(h2); } return; }
    /* Cells only: the instance root also carries data-rlog-day once a day is selected. */
    var cell = e.target.closest('.rlog__day[data-rlog-day]');
    if (cell) { var host = cell.closest('[data-routine-log]'); if (host) { host.setAttribute('data-rlog-day', cell.getAttribute('data-rlog-day')); render(host); } return; }
    var c = e.target.closest('[data-rlog-clear]');
    if (c && window.confirm('Clear your routine log on this device?')) { try { localStorage.removeItem(KEY); } catch (x) {} renderAll(); }
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
  /* Calendar reminders: two daily events, floating local time, built in the
     browser and downloaded as .ics. Nothing is sent anywhere. */
  function icsStamp(d) { return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z'; }
  function icsEvent(uid, summary, time) {
    var hm = (time || '08:00').split(':'), d = offset(0);
    var start = dateStr(d).replace(/-/g, '') + 'T' + pad(+hm[0]) + pad(+hm[1]) + '00';
    return ['BEGIN:VEVENT', 'UID:' + uid + '@xyro.co', 'DTSTAMP:' + icsStamp(new Date()), 'DTSTART:' + start, 'DURATION:PT15M', 'RRULE:FREQ=DAILY',
      'SUMMARY:' + summary, 'DESCRIPTION:As directed on the pack. Make the day count.', 'URL:https://xyro.co/pages/routine', 'END:VEVENT'];
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rlog-ics-form]'); if (!f) return;
    e.preventDefault();
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//XYRO//Routine//EN', 'CALSCALE:GREGORIAN', 'X-WR-CALNAME:XYRO Routine']
      .concat(icsEvent('xyro-power', 'XYRO Power \u00b7 daytime window', f.power.value))
      .concat(icsEvent('xyro-reset', 'XYRO Reset \u00b7 evening window', f.reset.value))
      .concat(['END:VCALENDAR']);
    var blob = new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'xyro-routine.ics';
    document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll); else renderAll();
  window.XyroRoutine = { toggle: toggle, load: load, render: renderAll };
})();
